module.exports = __webpack_public_path__ + "img/gdownload-btn.a4125bc1.png";